import React, { useContext, useState, useEffect } from "react";

import { AuthContext } from "../context/AuthContext";

import { db, serverTime, validDays } from "../Utils/firebase";

function Status() {
  const { userData, setUserData, userAuth } = useContext(AuthContext);
  const [btnText, setBtnText] = useState(null);
  const [disable, setDisable] = useState(true);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userData) {
      const now = new Date().getTime();
      if (userData.valid_until.toDate().getTime() < now) {
        setStatus(false);
        setDisable(false);
        setBtnText("Active Now");
      } else {
        setStatus(true);
        setDisable(true);

        const days = Math.ceil(
          (userData.valid_until.toDate().getTime() - now) / (1000 * 3600 * 24)
        );
        if (days <= 1) {
          setBtnText(`${days} day left`);
        } else {
          setBtnText(`${days} days left`);
        }
      }
    }
  }, [userData]);

  const activation = () => {
    setDisable(true);
    setBtnText("Activate ... ");

    const newDate = new Date().getTime() + validDays;
    const newValid = new Date(newDate);

    db.collection("user")
      .doc(userAuth.uid)
      .update({
        valid_until: newValid,
        updateAt: serverTime,
      })
      .then(() => {
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            setUserData(doc.data());
            setStatus(true);
            setDisable(true);
          })
          .catch((error) => {
            setError(error);
          });
      })
      .catch((error) => {
        setError(error);
      });
  };
  // const time = userData.valid_until.toDate().getTime() < new Date().getTime();
  // console.log("Compare " + time);
  // console.log("USer data time : " + userData.valid_until.toDate().getTime());
  // console.log("Time Now : " + new Date().getTime());

  const getDate = (stamp) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const times = stamp;

    const year = times.getFullYear();
    const month = monthNames[times.getMonth()];
    const date = times.getDate();

    const humanDate = date + " " + month + " " + year;

    // times.getHours(),
    // times.getMinutes(),
    // times.getSeconds();

    return humanDate;
  };

  return (
    <div className="status divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Status</h5>
      </div>
      <div className="status-active">
        {status ? <h1>Activated</h1> : <h1>Pending</h1>}

        <p className="text">
          Joined at : {getDate(userData.createAt.toDate())}
        </p>
      </div>
      <button
        className={
          disable
            ? "btn-in darktextColor textTitle disable"
            : "btn-in darktextColor textTitle "
        }
        disabled={disable}
        type="submit"
        onClick={activation}
      >
        {btnText}
      </button>

      {error ? (
        <p className="error-message text textMedium darktextColor">
          Terjadi Kesalahan , cobalah beberapa saat lagi!
        </p>
      ) : null}
    </div>
  );
}

export default Status;
